/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type AnsweredCommentContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly parent: {
        readonly author: {
            readonly username: string | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment">;
    } | null;
    readonly body: string | null;
    readonly createdAt: string;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly replyCount: number;
    readonly " $fragmentRefs": FragmentRefs<"MediaSectionContainer_comment" | "UsernameWithPopoverContainer_comment" | "ReactionButtonContainer_comment" | "UserTagsContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "AnsweredCommentContainer_comment";
};
export type AnsweredCommentContainer_comment$data = AnsweredCommentContainer_comment;
export type AnsweredCommentContainer_comment$key = {
    readonly " $data"?: AnsweredCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AnsweredCommentContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "CommentContainer_comment"
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "replyCount",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MediaSectionContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IgnoredTombstoneOrHideContainer_comment"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastViewerAction",
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '82636cc6006bd9adfbacae07f44a986d';
export default node;
